import { AssetPage } from '@/features/Transition360/AssetPage';
import { projectAssetParams } from '@/features/Transition360/routeParams';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/transition-360/projects/$projectId/assets/$projectAssetId',
)({
    params: projectAssetParams,
    component: AssetPageRoute,
});

function AssetPageRoute() {
    const { projectId, projectAssetId } = Route.useParams();
    return <AssetPage projectId={projectId} projectAssetId={projectAssetId} />;
}
